import { OptionKey } from '@common-fe/common-fe';

import { OrganizationTypes } from '@/common/constants';

export enum ContactStatuses {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  EXPRESS_VERIFICATION = 'EXPRESS_VERIFICATION',
  EXPRESS_ORGANIZATION = 'EXPRESS_ORGANIZATION',
}

export enum EmailCommunicationType {
  finance = 'FINANCE',
  planManagement = 'PLAN_MANAGEMENT',
  files = 'FILES',
  reports = 'REPORTS',
}

export interface EmailCommunication {
  finance: boolean;
  planManagement: boolean;
  files: boolean;
  reports: boolean;
}

export interface ContactDto {
  id: number;
  username: string;
  password?: string;
  role_id: OptionKey;
  title: string | null;
  first_name: string;
  last_name: string;
  email: string;
  phone: string | null;
  department: string | null;
  primary: boolean;
  external_identifier: string | null;
  contact_type: string;
  contact_status_type: string;
  email_communication_type_list: EmailCommunicationType[];
}

export interface Contact {
  id: number | string;
  title: string | null;
  firstName: string;
  lastName: string;
  email: string;
  phone: string | null;
  department: string | null;
  primary: boolean;
  externalIdentifier: string | null;
  contactType: string;
  contactStatusType: string;
  role: string;
  contactName: string;
  userName: string;
  emailCommunicationTypeList: EmailCommunicationType[];
}

export interface CreateContactPayload {
  firstName: string;
  lastName: string;
  email: string;
  userName: string;
  externalIdentifier: string;
  phoneNumber: string;
  title: string;
  department: string;
  primary: boolean;
  roleId?: OptionKey;
}

export interface CreateContactDto {
  username: string;
  password?: string;

  title?: string | null;
  first_name: string;
  last_name: string;
  email: string;
  // username: string;
  role_id: OptionKey;
  phone: string;
  department?: string | null;
  primary: boolean;
  external_identifier: string | null;
  contact_type: string;
  contact_status_type: string;
  email_communication_type_list?: EmailCommunicationType[];
  claims_teams_ids?: number[];
}

export interface RoleModel {
  description?: string;
  id: number;
  name: string;
}

export interface ContactInfo {
  id?: string;
  userName?: string;
  role?: string;
  title?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  clockIn: boolean;
  phone?: string;
  department?: string;
  primary?: true;
  externalIdentifier?: string;
  contactType?: OrganizationTypes;
  contactStatusType?: ContactStatuses;
  emailCommunicationTypeList?: EmailCommunicationType[];
  organizationId?: string;
  claimsAssigned?: boolean;
}
